import { FormControl, InputLabel, MenuItem, Select, SelectProps } from "@mui/material";
import { useEffect, useState } from "react";
import { selectDefaultProps } from "../../Forms/selectDefaultProps";
import { toKeyValuePairArray } from "../../Utils/maps";

type Props = {
  label?: string;
  optionsAsMap: Map<number, string>;
  onSelectionChange: (item: number) => void;
  notSelectedValue?: number;
  notSelectedText?: string;
  reset?: boolean;
};

export const EnumSelect = ({
  label,
  optionsAsMap,
  onSelectionChange,
  notSelectedValue = -1,
  notSelectedText = "None",
  reset,
  ...otherProps
}: Props & SelectProps) => {
  const [defaultValue, setDefaultValue] = useState<number>(notSelectedValue);

  useEffect(() => {
    setDefaultValue(notSelectedValue);
  }, [notSelectedValue, reset]);

  return (
    <FormControl fullWidth size="small" sx={{ width: "200px", pt: "0.3rem" }}>
      <InputLabel shrink>{label}</InputLabel>
      <Select
        {...selectDefaultProps}
        {...otherProps}
        fullWidth
        size="small"
        value={defaultValue}
        notched
        onChange={(event) => {
          onSelectionChange(Number(event.target.value));
          setDefaultValue(Number(event.target.value));
        }}
      >
        <MenuItem value={-1} disabled>
          -{notSelectedText}-
        </MenuItem>
        {toKeyValuePairArray(optionsAsMap).map((enumType) => (
          <MenuItem key={enumType.Key} value={enumType.Key}>
            {enumType.Value}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
